import { render, staticRenderFns } from "./giftDetail.vue?vue&type=template&id=4a607d26"
import script from "./giftDetail.vue?vue&type=script&lang=js"
export * from "./giftDetail.vue?vue&type=script&lang=js"
import style0 from "./giftDetail.vue?vue&type=style&index=0&id=4a607d26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports